import { Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { addNotification } from "../redux/slices/notificationsslice";
import {
  changePassword,
  setFirstLoginCompleted,
} from "../redux/slices/currentuserslice";
import { apiErrorsHandler, getErrorMessages } from "../api/httpclient";
import {
  Toolbar,
  ToolbarItem,
  ToolbarSeparator,
  ToolbarSpacer,
  Button,
  DropDownButton,
} from "@progress/kendo-react-buttons";
import { Form, FormElement, Field } from "@progress/kendo-react-form";
import { FormInput } from "../forms/form-components";
import { useNavigate } from "react-router-dom";
import { isEmptyObject } from "../lib/utils";

import i18next from "i18next";
import { useTranslation } from "react-i18next";

export const ChangePasswordForm = (props) => {
  const { onCancel, currentTheme, ...other } = props;
  const { t } = useTranslation();

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const appearance = useSelector((state) => state.appearance);

  const formValidator = (values) => {
    let formErrors = {};

    let oldPassword = values["OldPassword"];
    let password = values["Password"];
    let passwordConfirmed = values["PasswordConfirmed"];

    if (!oldPassword || oldPassword.trim().length == 0)
      formErrors = Object.assign(formErrors, {
        OldPassword: t("changepass.currentpass"),
      });

    if (!password || password.trim().length == 0)
      formErrors = Object.assign(formErrors, {
        Password: t("changepass.newpass"),
      });

    if (!passwordConfirmed || passwordConfirmed.trim().length == 0)
      formErrors = Object.assign(formErrors, {
        PasswordConfirmed: t("changepass.confirmpass"),
      });

    if (
      password &&
      password.trim() != "" &&
      passwordConfirmed &&
      passwordConfirmed.trim() != "" &&
      password != passwordConfirmed
    )
      formErrors = Object.assign(formErrors, {
        PasswordConfirmed: t("changepass.verify"),
      });

    if (
      password &&
      password.trim() != "" &&
      oldPassword &&
      oldPassword.trim() != "" &&
      password == oldPassword
    )
      formErrors = Object.assign(formErrors, {
        PasswordConfirmed: t("changepass.same"),
      });

    if (isEmptyObject(formErrors)) return undefined;

    return formErrors;
  };

  const onChange = (formRenderProps) => {
    let oldPassword = formRenderProps.valueGetter("OldPassword");
    let password = formRenderProps.valueGetter("Password");
    let passwordConfirmed = formRenderProps.valueGetter("PasswordConfirmed");

    let isOk = formValidator({
      OldPassword: oldPassword,
      Password: password,
      PasswordConfirmed: passwordConfirmed,
    });
    if (isOk !== undefined) return;

    //proceed
    dispatch(changePassword(oldPassword, password, passwordConfirmed)).then(
      (response) => {
        //notify
        dispatch(
          addNotification({
            text: t("changepass.success"),
            type: "success",
            closable: true,
            duration: 3,
            position: "topRight",
          })
        );

        if (!props.currentUser?.Subscription?.FirstLoginCompleted) {
          dispatch(setFirstLoginCompleted(true));
        }

        //close dialog
        onCancel();
      },
      (err) => {
        //hide loader
        //dispatch(setProcessing({processing: false}));

        const handleResponseReceived = (state, dispatch, navigate, payload) => {
          let errorMessages = payload?.data?.ErrorMessages;

          if (!errorMessages || errorMessages.length == 0)
            errorMessages = [t("changepass.unknown_error")];
          else {
            errorMessages = getErrorMessages(errorMessages, 1);
            dispatch(
              addNotification({
                text: errorMessages[0],
                type: "error",
                closable: true,
                duration: 3,
                position: "topRight",
              })
            );
          }
        };

        const handleUnhandled = (state, dispatch, navigate, payload) => {
          let errorMessage = t("changepass.unknown_error");
          dispatch(
            addNotification({
              text: errorMessage,
              type: "error",
              closable: true,
              duration: 3,
              position: "topRight",
            })
          );
        };

        apiErrorsHandler({}, dispatch, navigate, err, null, {
          responseReceived: handleResponseReceived,
          unhandled: handleUnhandled,
        });
      }
    );
  };

  return (
    <Fragment>
      <div className="change-password-form">
        <Form
          validator={formValidator}
          initialValues={{
            OldPassword: props.currentUser?.Subscription?.FirstPassword ?? "",
            Password: "",
            PasswordConfirmed: "",
          }}
          render={(formRenderProps) => {
            return (
              <FormElement
                horizontal={false}
                style={
                  {
                    // width: 250,
                  }
                }
              >
                <div className="toolbar">
                  <Toolbar>
                    <Fragment>
                      <ToolbarItem>
                        <Button
                          style={{
                            color: currentTheme.primary,
                            backgroundColor: "transparent",
                          }}
                          icon="save"
                          onClick={(e) => onChange(formRenderProps)}
                        >
                          {t("changepass.change")}
                        </Button>
                      </ToolbarItem>
                      <ToolbarSeparator />
                    </Fragment>
                    <Fragment>
                      <ToolbarItem>
                        <Button
                          style={{
                            color: currentTheme.primary,
                            backgroundColor: "transparent",
                          }}
                          icon="cancel"
                          onClick={(e) => onCancel()}
                        >
                          {t("changepass.cancel")}
                        </Button>
                      </ToolbarItem>
                      <ToolbarSeparator />
                    </Fragment>
                  </Toolbar>
                </div>
                <div className="form-content">
                  <Field
                    id={"OldPassword"}
                    name={"OldPassword"}
                    label={t("changepass.currentpass1")}
                    type="password"
                    component={FormInput}
                    autoComplete="new-password"
                    onChange={(e) =>
                      formRenderProps.onChange("OldPassword", {
                        value: e.value,
                      })
                    }
                    maxLength={50}
                    style={{ marginTop: 2 }}
                    autoFocus={true}
                  />
                  <Field
                    id={"Password"}
                    name={"Password"}
                    label={t("changepass.newpass1")}
                    type="password"
                    component={FormInput}
                    autoComplete="new-password"
                    onChange={(e) =>
                      formRenderProps.onChange("Password", { value: e.value })
                    }
                    maxLength={50}
                  />
                  <Field
                    id={"PasswordConfirmed"}
                    name={"PasswordConfirmed"}
                    label={t("changepass.confirmpass1")}
                    type="password"
                    component={FormInput}
                    onChange={(e) =>
                      formRenderProps.onChange("PasswordConfirmed", {
                        value: e.value,
                      })
                    }
                    maxLength={50}
                  />
                </div>
              </FormElement>
            );
          }}
        />
      </div>
      <style>
        {`
                    .change-password-form
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                        height: 100%;
                         direction:${appearance.isRightToLeft ? "rtl" : "ltr"}  
                    }

                    /*form toolbar*/
                    .change-password-form .toolbar .k-toolbar
                    {
                      width: 100%;
                      border-left: none !important;
                      border-bottom: 1px solid ${currentTheme.separatorColor};
                      border-top: none !important;
                      border-right: none !important;
                      padding: 3px 4px 2px 0px;
                      background-color: ${
                        currentTheme.appBarBg
                      }; /*transparent;*/
                    }

                    .change-password-form .toolbar .k-button
                    {
                      /*the toolbar buttons*/
                      border: none;
                      padding: 6px 8px;
                    }

                    .change-password-form .toolbar .k-separator 
                    {
                        border-color: ${currentTheme.appBarLinkColor};/* ${
          currentTheme.primary
        }*/
                    }

                    .change-password-form .toolbar .k-toolbar .k-split-button:focus, .form-root .toolbar .k-toolbar .k-split-button.k-focus,
                    .change-password-form .toolbar .k-toolbar .k-button-solid-base:focus, .form-root .toolbar .k-toolbar .k-button-solid-base.k-focus
                    {
                        box-shadow: none !important;
                        border: none !important;
                    }

                    .change-password-form .toolbar .k-toolbar .k-button:active::before, .change-password-form .toolbar .k-toolbar .k-button:hover::before,
                    .change-password-form .toolbar .k-toolbar .k-button:focus::before, .change-password-form .toolbar .k-toolbar .k-button:focus-within::before                        
                    {
                        opacity: 0 !important;
                        border: none !important;
                        box-shadow: none !important;
                    }

                    .change-password-form .toolbar .k-toolbar .k-dropdown-button.k-focus .k-button::after
                    {
                        /*border: 1px solid ${
                          currentTheme.componentBg
                        } !important;*/
                        box-shadow: none !important;
                    }                       

                    .change-password-form .toolbar .k-toolbar .k-button .k-button-text
                    {
                        font-size: 13px;
                        font-weight: 400;
                        color: ${currentTheme.appBarLinkColor};//${
          currentTheme.componentText
        };
                    }

                    .change-password-form .toolbar .k-button-icon
                    {
                      font-weight: 500;
                      color: ${currentTheme.appBarLinkColor};/*${
          currentTheme.primary
        };*/
                    }

                    .change-password-form .toolbar .k-toolbar .k-button:hover .k-button-text
                    {
                        font-weight: 700;
                        font-size: 12.2px;
                    }
                    /*form toolbar*/


                    /*form content*/
                    .change-password-form .form-content
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        overflow: auto;
                        padding: 6px 24px 24px 24px;
                    }
                    /*form content*/


                    .change-password-form .k-form
                    {
                        display: flex;
                        flex-direction: column;
                        align-items: stretch;
                        flex: 1;
                        overflow: hidden;
                    }

                    @media (max-width: 1024px)
                    {
                        .change-password-form-dialog
                        {
                            width: calc(100vw - 32px) !important;
                            max-width: calc(100vw - 32px) !important;
                            max-height: calc(100dvh - 32px - env(safe-area-inset-bottom));
                            left: 16px !important;
                            top: 16px !important;
                        }

                        .change-password-form-dialog .k-dialog
                        {
                            width: 100% !important;
                            max-width: 100% !important;
                            max-height: calc(100dvh - 32px - env(safe-area-inset-bottom));
                            box-sizing: border-box;
                        }

                        .change-password-form-dialog .k-dialog-content
                        {
                            width: 100% !important;
                            max-width: 100% !important;
                            max-height: calc(100dvh - 32px - env(safe-area-inset-bottom));
                            box-sizing: border-box;
                        }

                        .change-password-form .toolbar .k-toolbar
                        {
                            flex-wrap: wrap;
                            gap: 4px;
                            padding: 6px;
                        }

                        .change-password-form .toolbar .k-separator
                        {
                            display: none;
                        }

                        .change-password-form .form-content
                        {
                            padding: 12px 16px 20px;
                            padding-bottom: calc(20px + env(safe-area-inset-bottom));
                        }

                        .change-password-form .form-content .k-form-field,
                        .change-password-form .form-content .k-form-field-wrap,
                        .change-password-form .form-content .k-input
                        {
                            min-width: 0;
                            width: 100%;
                            box-sizing: border-box;
                        }
                    }

                    `}
      </style>
    </Fragment>
  );
};
